import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Star, Building2 } from 'lucide-react';
import { testimonialsData } from '../mockData';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-slate-50">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-blue-100 text-blue-700 hover:bg-blue-200 px-4 py-1.5 text-sm font-semibold">
            CLIENT TESTIMONIALS
          </Badge>
          <h2 className="text-5xl font-bold text-slate-900 mb-6">
            Trusted By Industry Leaders
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our clients say about working with AI ASAP
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {testimonialsData.map((testimonial) => (
            <Card 
              key={testimonial.id}
              className="bg-white border-2 hover:border-blue-500 transition-all duration-300 hover:shadow-xl group"
            >
              <CardContent className="p-8">
                {/* Rating Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, idx) => (
                    <Star key={idx} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-slate-700 text-lg leading-relaxed mb-6 italic">
                  "{testimonial.quote}"
                </blockquote>

                {/* Author Info */}
                <div className="border-t border-slate-200 pt-6 flex items-start justify-between">
                  <div>
                    <div className="font-bold text-slate-900 text-lg mb-1">
                      {testimonial.author}
                    </div>
                    <div className="text-slate-600 text-sm mb-1">
                      {testimonial.role}
                    </div>
                    <div className="flex items-center gap-2 text-sm text-slate-500">
                      <Building2 className="h-4 w-4" />
                      {testimonial.company}
                    </div>
                  </div>
                  <div className="text-right">
                    <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-200 mb-1">
                      {testimonial.industry}
                    </Badge>
                    <div className="text-xs text-slate-500 font-semibold">
                      {testimonial.revenue}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">500+</div>
            <div className="text-slate-600 font-medium">Active Clients</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">4.9/5</div>
            <div className="text-slate-600 font-medium">Average Rating</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">$2.4B+</div>
            <div className="text-slate-600 font-medium">Revenue Generated</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">99.9%</div>
            <div className="text-slate-600 font-medium">Uptime SLA</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
